import Axios, { AxiosInstance } from 'axios'
import { AdminAPI } from './modules/admin'

import { AuthAPI } from './modules/auth'
import { ConsultationAPI } from './modules/consultation'
import { DocumentAPI } from './modules/document'
import { EstablishmentAPI } from './modules/establishment'
import { PatientAPI } from './modules/patient'
import { RoomAPI } from './modules/room'
import { SettingsAPI } from './modules/settings'
import { StaffAPI } from './modules/staff'
import { WaitingRoomAPI } from './modules/waiting-room'

type ApiConfig = {
  baseUrl: string
}

export class Api {
  public axios: AxiosInstance

  private _admin: AdminAPI
  private _auth: AuthAPI
  private _consultation: ConsultationAPI
  private _document: DocumentAPI
  private _establishment: EstablishmentAPI
  private _patient: PatientAPI
  private _room: RoomAPI
  private _settings: SettingsAPI
  private _staff: StaffAPI
  private _waitingRoom: WaitingRoomAPI

  constructor(config: ApiConfig) {
    this.axios = Axios.create({ baseURL: config.baseUrl })

    this._admin = new AdminAPI(this.axios)
    this._auth = new AuthAPI(this.axios)
    this._consultation = new ConsultationAPI(this.axios)
    this._document = new DocumentAPI(this.axios)
    this._establishment = new EstablishmentAPI(this.axios)
    this._patient = new PatientAPI(this.axios)
    this._room = new RoomAPI(this.axios)
    this._settings = new SettingsAPI(this.axios)
    this._staff = new StaffAPI(this.axios)
    this._waitingRoom = new WaitingRoomAPI(this.axios)
  }

  /** APIs */

  get admin() {
    return this._admin
  }

  get auth() {
    return this._auth
  }

  get consultation() {
    return this._consultation
  }

  get document() {
    return this._document
  }

  get establishment() {
    return this._establishment
  }

  get patient() {
    return this._patient
  }

  get room() {
    return this._room
  }

  get settings() {
    return this._settings
  }

  get staff() {
    return this._staff
  }

  get waitingRooom() {
    return this._waitingRoom
  }

  /** END APIs */
}
